export class ShareContentProvider {
	static shareToWhatsapp(message: string): void {
		const _message = encodeURI(message)
		window.open(`https://api.whatsapp.com/send/?text=${_message}`, '_blank')
	}
}
